export const getEnvironmentFromBackendUrl = (url) => {
  const parts = url.split("/");
  const lastPart = parts[parts.length - 1];

  if (["dev", "uat", "prod"].includes(lastPart)) {
    return lastPart;
  } else {
    return "unknown";
  }
};
